export class FacebookPageAlreadyRequestedException extends Error {
  constructor(message) {
    super(message);
  }
}